import { render, staticRenderFns } from "./ProductsBulk.vue?vue&type=template&id=5fdbb069&"
import script from "./ProductsBulk.vue?vue&type=script&lang=js&"
export * from "./ProductsBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports